/**
 * Design tokens shared across the dashboard.
 * Prefer these over hardcoded values so the look can evolve in one place.
 */

export const SECTION_GAP = 24;
export const RADIUS = 10;
export const BORDER = "1px solid #eaeaea";
export const MUTED = "#6b7280";
export const SECONDARY = "#8c8c8c";

/** Card / input background — pure white for maximum contrast over page bg. */
export const SURFACE = "#ffffff";
/** Primary text color used for values / strong content. */
export const TEXT_STRONG = "#1f2937";
/** Soft amber for inline warnings — less saturated than AntD's `type=warning`. */
export const WARNING_SOFT = "#b45309";
